import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import AddItemScheduler from "./AddItemScheduler.js";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../assets/icons/close.png";
import SchedulerDetailsTable from "./SchedulerView/SchedulerDetailsViewWithTable/SchedulerDetailsTable.tsx";
import EditItemScheduler from "./EditItemScheduler.tsx";

function EditItemSchedulerSelectionDialog(props) {
  const { open, onClose, foodItems } = props;
  const apiAddress = process.env.REACT_APP_SECRET;
  const [selectedFoodItem, setSelectedFoodItem] = useState(null);
  const [inventoryData, setInventoryData] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [schedulerDatas, setSchedulerDatas] = useState([]);
  const [scheduleSelections, setScheduleSelections] = useState([]);
  const [activeTab, setActiveTab] = useState("SaleHourSchedule");
  const [scheduleDetails, setScheduleDetails] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [Schedule, setSchedule] = useState([]);

  const formattedFoodItems = foodItems.map((item) => ({
    id: item.id,
    title: item.title,
  }));
console.log(inventoryData)
const [updateddata, setUpdateddata] = useState([]);
const sethandleInventoryDetails = (data) => {
  setUpdateddata(data)
};
console.log(updateddata)
console.log(selectedSchedule)

const [SectionId,setSectionId]=useState([]);
console.log(SectionId)
useEffect(() => {
  axios
        .get(`${apiAddress}/api/Schedule`)
        .then((response) => {
          const formattedSchedules = response.data.map((schedule) => ({
            id: schedule.scheduleId,
            title: schedule.scheduleName,
          }));
          setSchedulerDatas(formattedSchedules);
        })
        .catch((error) => {
          console.error("Failed to load schedules:", error);
          toast.error("Failed to load schedules");
        });
},[])
  useEffect(() => {
    
    if (selectedFoodItem) {
      // Load inventory data
      axios
        .get(
          `${apiAddress}/api/FoodItems/GetInventoryAllDetailsByContentId?categorycontentid=${selectedFoodItem.id}`
        )
        .then((response) => {
          const data = response.data;
          setInventoryData(data);
  
          if (data.inventoryGetInfoView && data.inventoryGetInfoView.length > 0) {
            const schedulerId = data.inventoryGetInfoView[0].schedulerId;
            if (schedulerId) {
              // Preselect schedule if it exists
              const matchedSchedule = schedulerDatas.find(
                (schedule) => schedule.id === schedulerId
              );
              setSelectedSchedule(matchedSchedule || null);
              setSchedule(matchedSchedule ? [matchedSchedule] : []);
              fetchScheduleDetails(schedulerId);
             
              
            }
          }

        })
        .catch((error) => {
          console.error("Failed to fetch inventory details:", error);
          setInventoryData(null);
        });
  
      // Fetch available schedules
      
    }
  }, [selectedFoodItem, apiAddress]);
  


  const handleFoodItemSelection = (event, value) => {
    setSelectedFoodItem(value || null);
  };

  const handleTabChange = (event, newTab) => {
    if (newTab === "InventoryScheduler" && !selectedSchedule) {
      toast.error("Please select a schedule before switching to Inventory Scheduler.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return; 
    }
    setActiveTab(newTab);
  };
  

  // const handleScheduleChange = (event, newValue) => {
  //   setSelectedSchedule(newValue);
  //   setScheduleSelections([newValue]);
  //   fetchScheduleDetails(newValue?.id);
  //   setSchedule([newValue]);
  // // if (Schedule.length === 0) {
  // //   setSchedule([newValue]);
  // // }
  // };

  const handleScheduleChange = (event, newValue) => {
  setSelectedSchedule(newValue);
  setScheduleSelections(newValue ? [newValue] : []);
  setSchedule(newValue ? [newValue] : []);

  if (newValue?.id) {
    fetchScheduleDetails(newValue.id);
  } else {
    // Clear previous schedule details if no schedule is selected
    setScheduleDetails([]);
  }
};


  const fetchScheduleDetails = (scheduleId) => {
     if (!scheduleId) return; // Prevent API call if ID is invalid
    axios
      .post(`${apiAddress}/api/Schedule/getschedulebyidlist`, [scheduleId])
      .then((response) => {
        setScheduleDetails(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch schedule details:", error);
        setScheduleDetails(null);
        toast.error("Failed to fetch schedule details");
      });
  };

  console.log(Schedule);
  console.log(selectedSchedule);
  const handleUpdate = () => {
    const restaurant = JSON.parse(localStorage.getItem('restaurant'));
    let list = [];

      Schedule.forEach((sc) => {
        let obj = {
          salesHourSetupId: 'string',
          scheduleId: sc?.id,
          inventoryCategoryTypeId: 3,
          inventoryCategoryContentId:selectedFoodItem?.id,
          descriedDailyItem: true,
          restaurantId: restaurant.id,
          creationId: 'string',
        };
        list.push(obj);
        console.log(obj);
      });
    
    if (list.length > 0) {
      axios
        .post(apiAddress + '/api/InventorySetup/inventoryCategoryContentId', list)
        .then((res) => {
          toast.success('Sale Hour scheduler Updated successfully');
          saveInventory(res.data[0].salesHourSetupId, res.data[0].scheduleId);
        })
        .catch((err) => {
          console.error(err);
        });
    }
    console.log(list);
  };
  
  const saveInventory = (id, scheduleId) => {
  
    if (updateddata) {
      const updatedInventoryData = {
        ...updateddata,
        salesHourSetupId: id,
        SchedulerId: scheduleId,
      };
  
      console.log(updatedInventoryData)
      axios
        .post(apiAddress + '/api/InventorySetup/InsertIntoInventoryScheduler', updatedInventoryData)
        .then((res) => {
          console.warn('OK');
        })
        .catch((err) => {
          console.error(err);
        });
     }
  };

  // Reset the states when the dialog is closed
  const handleClose = () => {
    setSelectedFoodItem(null);
    setSelectedSchedule(null);
    setScheduleSelections([]);
    setScheduleDetails([]);
    setInventoryData([]);
    setActiveTab("SaleHourSchedule");
    onClose(); // Ensure the dialog also closes
  };

  return (
    <Dialog fullWidth={true} maxWidth={"xl"} open={open} onClose={handleClose}>
      <SweetAlertModal
        headerText="Do you want to leave without saving?"
        bodyText="All changes made will be lost"
        open={openMenuCloseConfirmaitonModal}
        onyes={() => {
          setopenMenuCloseConfirmaitonModal(false);
          handleClose(); // Close the dialog and reset states
        }}
        close={() => setopenMenuCloseConfirmaitonModal(false)}
      />

      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <span style={{ color: "#2a7fd4" }}>
            GoTaste - Edit Food Item Scheduler
          </span>
          <Grid item xs={6}>
            <DialogActions>
              <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <Grid container spacing={2} sx={{ padding: "0.5rem" }}>
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "2rem", alignItems: "center" }}
          >
            <Grid item xs={1.5} sx={{ marginLeft: "2rem" }}>
              <Typography>Select Food Item</Typography>
            </Grid>
            <Grid item xs={5}>
              <Autocomplete
                id="food-item-autocomplete"
                options={formattedFoodItems}
                getOptionLabel={(option) => option.title}
                value={selectedFoodItem}
                onChange={handleFoodItemSelection}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a Food Item"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>

          {selectedFoodItem && (
            <>
              <Grid item xs={12}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                  <Tab value="SaleHourSchedule" label="Sale Hour Schedule" />
                  <Tab value="InventoryScheduler" label="Inventory Scheduler" />
                </Tabs>
              </Grid>

              <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
                {activeTab === "SaleHourSchedule" && (
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <Typography>Select Schedule</Typography>
                      <Autocomplete
                        id="schedule-select"
                        options={schedulerDatas}
                        getOptionLabel={(option) => option.title}
                        value={selectedSchedule}  
                        onChange={handleScheduleChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Schedule"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {scheduleDetails &&
                      Array.isArray(scheduleDetails.schedulerDatas) &&
                      scheduleDetails.schedulerDatas.length > 0 ? (
                        <SchedulerDetailsTable
                          addedtempSchedulers={scheduleDetails.schedulerDatas}
                        />
                      ) : (
                        <Typography>No schedule details available</Typography>
                      )}
                    </Grid>
                  </Grid>
                )}

                {activeTab === "InventoryScheduler" && (
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <Typography>Selected Schedule in Inventory</Typography>
                      <Autocomplete
                        id="inventory-schedule-select"
                        options={schedulerDatas}
                        getOptionLabel={(option) => option.title}
                        value={selectedSchedule || null} 
                        onChange={handleScheduleChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Schedule"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <EditItemScheduler
                        inventoryData={inventoryData}
                        sectionId={SectionId}
                        sectionTitle={formattedFoodItems.title}
                        addedSchedulers={scheduleDetails.schedulerDatas}
                        handleInventoryDetails={sethandleInventoryDetails}
                        selectedFoodItem={selectedFoodItem.id}
                      />
                    </Grid>
                  </Grid>
                )}
              </DialogContent>
            </>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => setopenMenuCloseConfirmaitonModal(true)}
          color="primary"
        >
          Close
        </Button>
        <Button onClick={handleUpdate} color="primary">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditItemSchedulerSelectionDialog;
